import L from 'L'
import {myIcon} from './icon'
import {event} from '../../utils'

var theMarker = null
module.exports = (map, location) => {
  if (!theMarker) {
    var point = location || map.taiwanCenter

    var myMarker = L.marker(point, {icon: myIcon, draggable: 'true'}).addTo(map)

    event.emit('setLocationNumfunction', point)

    myMarker.on('drag', (e) => {
      event.emit('setLocationNumfunction', e.target.getLatLng())
    })

    myMarker.destroy = () => {
      if (document.getElementById('myMarker')) {
        document.getElementById('myMarker').removeEventListener('click', () => {
          console.log('destory')
        })
      }
      map.removeLayer(myMarker)
      theMarker = null
    }
    theMarker = myMarker
  }
  return theMarker
}



// WEBPACK FOOTER //
// ./src/assets/js/myMarker.js